import { getOnlyNumbers } from '@/utils/index';

export const capitalize = (value: string): string => {
  return `${value[0].toUpperCase()}${value.slice(1).toLowerCase()}`;
};

export const formatFirstName = (value: string): string => {
  if (!value) return '';

  const [firstName] = value.split(' ');
  return capitalize(firstName);
};
export const removeAccentsAndSetUpperCase = (value = ''): string => {
  const map: { [key: string]: string } = {
    â: 'a',
    Â: 'A',
    à: 'a',
    À: 'A',
    á: 'a',
    Á: 'A',
    ã: 'a',
    Ã: 'A',
    ê: 'e',
    Ê: 'E',
    è: 'e',
    È: 'E',
    é: 'e',
    É: 'E',
    î: 'i',
    Î: 'I',
    ì: 'i',
    Ì: 'I',
    í: 'i',
    Í: 'I',
    õ: 'o',
    Õ: 'O',
    ô: 'o',
    Ô: 'O',
    ò: 'o',
    Ò: 'O',
    ó: 'o',
    Ó: 'O',
    ü: 'u',
    Ü: 'U',
    û: 'u',
    Û: 'U',
    ú: 'u',
    Ú: 'U',
    ù: 'u',
    Ù: 'U',
    ç: 'c',
    Ç: 'C',
  };
  return (
    value
      // eslint-disable-next-line no-useless-escape
      .replace(/[\W\[\] ]/g, (a) => {
        return map[a] || a;
      })
      .normalize('NFD')
      .toUpperCase()
  );
};

export const removeAccentAndSpace = (value: string): string => {
  return value
    .normalize('NFD')
    .toLowerCase()
    .replace(/[^a-zA-Zs]/g, '');
};

export const formatCPF = (value: string): string =>
  getOnlyNumbers(value).replace(
    /(\d{3})?(\d{3})?(\d{3})?(\d{2})/,
    '$1.$2.$3-$4',
  );

export const formatPhone = (value: string): string =>
  getOnlyNumbers(value).replace(/(\d{2})?(\d{5})?(\d{4})/, '$1 $2-$3');

export const formatCEP = (value: string): string =>
  getOnlyNumbers(value).replace(/(\d{5})?(\d{2})/, '$1-$2');

export const removeAccentAndSpaceAndSetLowerCase = (value = ''): string => {
  const map: { [key: string]: string } = {
    â: 'a',
    Â: 'A',
    à: 'a',
    À: 'A',
    á: 'a',
    Á: 'A',
    ã: 'a',
    Ã: 'A',
    ê: 'e',
    Ê: 'E',
    è: 'e',
    È: 'E',
    é: 'e',
    É: 'E',
    î: 'i',
    Î: 'I',
    ì: 'i',
    Ì: 'I',
    í: 'i',
    Í: 'I',
    õ: 'o',
    Õ: 'O',
    ô: 'o',
    Ô: 'O',
    ò: 'o',
    Ò: 'O',
    ó: 'o',
    Ó: 'O',
    ü: 'u',
    Ü: 'U',
    û: 'u',
    Û: 'U',
    ú: 'u',
    Ú: 'U',
    ù: 'u',
    Ù: 'U',
    ç: 'c',
    Ç: 'C',
    ' ': '-',
  };
  return (
    value
      // eslint-disable-next-line no-useless-escape
      .replace(/[\W\[\] ]/g, (a) => {
        return map[a] || a;
      })
      .normalize('NFD')
      .toLowerCase()
  );
};
